/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedChromelessRouteImport } from './routes/_authenticated-chromeless'
import { Route as AccountUnderReviewRouteImport } from './routes/account-under-review'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SessionExpiredRouteImport } from './routes/session-expired'
import { Route as AuthenticatedChromelessApplicationSuccessRouteRouteImport } from './routes/_authenticated-chromeless/application-success/route'
import { Route as AuthenticatedChromelessCommonApplicationRouteRouteImport } from './routes/_authenticated-chromeless/common-application/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedDashboardRouteRouteImport } from './routes/_authenticated/dashboard/route'
import { Route as AuthenticatedPerformanceRouteRouteImport } from './routes/_authenticated/performance/route'
import { Route as AuthenticatedTransfersRouteRouteImport } from './routes/_authenticated/transfers/route'
import { Route as AuthenticatedChromelessCommonApplicationIndexRouteImport } from './routes/_authenticated-chromeless/common-application/index'
import { Route as AuthenticatedChromelessCommonApplicationStepPathRouteImport } from './routes/_authenticated-chromeless/common-application/$stepPath'
import { Route as AuthenticatedDashboardCheckingRouteImport } from './routes/_authenticated/dashboard/checking'
import { Route as AuthenticatedDashboardExternalRouteImport } from './routes/_authenticated/dashboard/external'
import { Route as AuthenticatedDashboardHighYieldSavingsRouteImport } from './routes/_authenticated/dashboard/high-yield-savings'
import { Route as AuthenticatedGoalsIndexRouteImport } from './routes/_authenticated/goals/index'
import { Route as AuthenticatedTransfersAccountsPendingRouteImport } from './routes/_authenticated/transfers/accounts-pending'
import { Route as AuthenticatedTransfersAddAccountsRouteImport } from './routes/_authenticated/transfers/add-accounts'
import { Route as AuthenticatedTransfersDepositRouteImport } from './routes/_authenticated/transfers/deposit'
import { Route as AuthenticatedTransfersHighYieldSavingsRouteImport } from './routes/_authenticated/transfers/high-yield-savings'
import { Route as AuthenticatedTransfersInProgressRouteImport } from './routes/_authenticated/transfers/in-progress'
import { Route as AuthenticatedTransfersWithdrawRouteImport } from './routes/_authenticated/transfers/withdraw'
import { Route as AuthenticatedDashboardCheckingIndexRouteImport } from './routes/_authenticated/dashboard/checking/index'
import { Route as AuthenticatedDashboardExternalIndexRouteImport } from './routes/_authenticated/dashboard/external/index'
import { Route as AuthenticatedDashboardHighYieldSavingsIndexRouteImport } from './routes/_authenticated/dashboard/high-yield-savings/index'
import { Route as AuthenticatedDashboardCheckingAccountIdSettingsRouteImport } from './routes/_authenticated/dashboard/checking/$accountId/settings'
import { Route as AuthenticatedDashboardExternalAccountIdSettingsRouteImport } from './routes/_authenticated/dashboard/external/$accountId/settings'
import { Route as AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRouteImport } from './routes/_authenticated/dashboard/high-yield-savings/$accountId/settings'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedChromelessRoute = AuthenticatedChromelessRouteImport.update({
  id: '/_authenticated-chromeless',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountUnderReviewRoute = AccountUnderReviewRouteImport.update({
  id: '/account-under-review',
  path: '/account-under-review',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionExpiredRoute = SessionExpiredRouteImport.update({
  id: '/session-expired',
  path: '/session-expired',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedChromelessApplicationSuccessRouteRoute =
  AuthenticatedChromelessApplicationSuccessRouteRouteImport.update({
    id: '/application-success',
    path: '/application-success',
    getParentRoute: () => AuthenticatedChromelessRoute,
  } as any)
const AuthenticatedChromelessCommonApplicationRouteRoute =
  AuthenticatedChromelessCommonApplicationRouteRouteImport.update({
    id: '/common-application',
    path: '/common-application',
    getParentRoute: () => AuthenticatedChromelessRoute,
  } as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRouteRoute =
  AuthenticatedDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPerformanceRouteRoute =
  AuthenticatedPerformanceRouteRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTransfersRouteRoute =
  AuthenticatedTransfersRouteRouteImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChromelessCommonApplicationIndexRoute =
  AuthenticatedChromelessCommonApplicationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedChromelessCommonApplicationRouteRoute,
  } as any)
const AuthenticatedChromelessCommonApplicationStepPathRoute =
  AuthenticatedChromelessCommonApplicationStepPathRouteImport.update({
    id: '/$stepPath',
    path: '/$stepPath',
    getParentRoute: () => AuthenticatedChromelessCommonApplicationRouteRoute,
  } as any)
const AuthenticatedDashboardCheckingRoute =
  AuthenticatedDashboardCheckingRouteImport.update({
    id: '/checking',
    path: '/checking',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardExternalRoute =
  AuthenticatedDashboardExternalRouteImport.update({
    id: '/external',
    path: '/external',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardHighYieldSavingsRoute =
  AuthenticatedDashboardHighYieldSavingsRouteImport.update({
    id: '/high-yield-savings',
    path: '/high-yield-savings',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedGoalsIndexRoute = AuthenticatedGoalsIndexRouteImport.update({
  id: '/goals/',
  path: '/goals/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTransfersAccountsPendingRoute =
  AuthenticatedTransfersAccountsPendingRouteImport.update({
    id: '/accounts-pending',
    path: '/accounts-pending',
    getParentRoute: () => AuthenticatedTransfersRouteRoute,
  } as any)
const AuthenticatedTransfersAddAccountsRoute =
  AuthenticatedTransfersAddAccountsRouteImport.update({
    id: '/add-accounts',
    path: '/add-accounts',
    getParentRoute: () => AuthenticatedTransfersRouteRoute,
  } as any)
const AuthenticatedTransfersDepositRoute =
  AuthenticatedTransfersDepositRouteImport.update({
    id: '/deposit',
    path: '/deposit',
    getParentRoute: () => AuthenticatedTransfersRouteRoute,
  } as any)
const AuthenticatedTransfersHighYieldSavingsRoute =
  AuthenticatedTransfersHighYieldSavingsRouteImport.update({
    id: '/high-yield-savings',
    path: '/high-yield-savings',
    getParentRoute: () => AuthenticatedTransfersRouteRoute,
  } as any)
const AuthenticatedTransfersInProgressRoute =
  AuthenticatedTransfersInProgressRouteImport.update({
    id: '/in-progress',
    path: '/in-progress',
    getParentRoute: () => AuthenticatedTransfersRouteRoute,
  } as any)
const AuthenticatedTransfersWithdrawRoute =
  AuthenticatedTransfersWithdrawRouteImport.update({
    id: '/withdraw',
    path: '/withdraw',
    getParentRoute: () => AuthenticatedTransfersRouteRoute,
  } as any)
const AuthenticatedDashboardCheckingIndexRoute =
  AuthenticatedDashboardCheckingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardCheckingRoute,
  } as any)
const AuthenticatedDashboardExternalIndexRoute =
  AuthenticatedDashboardExternalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardExternalRoute,
  } as any)
const AuthenticatedDashboardHighYieldSavingsIndexRoute =
  AuthenticatedDashboardHighYieldSavingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardHighYieldSavingsRoute,
  } as any)
const AuthenticatedDashboardCheckingAccountIdSettingsRoute =
  AuthenticatedDashboardCheckingAccountIdSettingsRouteImport.update({
    id: '/$accountId/settings',
    path: '/$accountId/settings',
    getParentRoute: () => AuthenticatedDashboardCheckingRoute,
  } as any)
const AuthenticatedDashboardExternalAccountIdSettingsRoute =
  AuthenticatedDashboardExternalAccountIdSettingsRouteImport.update({
    id: '/$accountId/settings',
    path: '/$accountId/settings',
    getParentRoute: () => AuthenticatedDashboardExternalRoute,
  } as any)
const AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRoute =
  AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRouteImport.update({
    id: '/$accountId/settings',
    path: '/$accountId/settings',
    getParentRoute: () => AuthenticatedDashboardHighYieldSavingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/account-under-review': typeof AccountUnderReviewRoute
  '/login': typeof LoginRoute
  '/session-expired': typeof SessionExpiredRoute
  '/application-success': typeof AuthenticatedChromelessApplicationSuccessRouteRoute
  '/common-application': typeof AuthenticatedChromelessCommonApplicationRouteRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/performance': typeof AuthenticatedPerformanceRouteRoute
  '/transfers': typeof AuthenticatedTransfersRouteRouteWithChildren
  '/common-application/$stepPath': typeof AuthenticatedChromelessCommonApplicationStepPathRoute
  '/dashboard/checking': typeof AuthenticatedDashboardCheckingRouteWithChildren
  '/dashboard/external': typeof AuthenticatedDashboardExternalRouteWithChildren
  '/dashboard/high-yield-savings': typeof AuthenticatedDashboardHighYieldSavingsRouteWithChildren
  '/transfers/accounts-pending': typeof AuthenticatedTransfersAccountsPendingRoute
  '/transfers/add-accounts': typeof AuthenticatedTransfersAddAccountsRoute
  '/transfers/deposit': typeof AuthenticatedTransfersDepositRoute
  '/transfers/high-yield-savings': typeof AuthenticatedTransfersHighYieldSavingsRoute
  '/transfers/in-progress': typeof AuthenticatedTransfersInProgressRoute
  '/transfers/withdraw': typeof AuthenticatedTransfersWithdrawRoute
  '/common-application/': typeof AuthenticatedChromelessCommonApplicationIndexRoute
  '/goals/': typeof AuthenticatedGoalsIndexRoute
  '/dashboard/checking/': typeof AuthenticatedDashboardCheckingIndexRoute
  '/dashboard/external/': typeof AuthenticatedDashboardExternalIndexRoute
  '/dashboard/high-yield-savings/': typeof AuthenticatedDashboardHighYieldSavingsIndexRoute
  '/dashboard/checking/$accountId/settings': typeof AuthenticatedDashboardCheckingAccountIdSettingsRoute
  '/dashboard/external/$accountId/settings': typeof AuthenticatedDashboardExternalAccountIdSettingsRoute
  '/dashboard/high-yield-savings/$accountId/settings': typeof AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/account-under-review': typeof AccountUnderReviewRoute
  '/login': typeof LoginRoute
  '/session-expired': typeof SessionExpiredRoute
  '/application-success': typeof AuthenticatedChromelessApplicationSuccessRouteRoute
  '/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/performance': typeof AuthenticatedPerformanceRouteRoute
  '/transfers': typeof AuthenticatedTransfersRouteRouteWithChildren
  '/common-application/$stepPath': typeof AuthenticatedChromelessCommonApplicationStepPathRoute
  '/transfers/accounts-pending': typeof AuthenticatedTransfersAccountsPendingRoute
  '/transfers/add-accounts': typeof AuthenticatedTransfersAddAccountsRoute
  '/transfers/deposit': typeof AuthenticatedTransfersDepositRoute
  '/transfers/high-yield-savings': typeof AuthenticatedTransfersHighYieldSavingsRoute
  '/transfers/in-progress': typeof AuthenticatedTransfersInProgressRoute
  '/transfers/withdraw': typeof AuthenticatedTransfersWithdrawRoute
  '/common-application': typeof AuthenticatedChromelessCommonApplicationIndexRoute
  '/goals': typeof AuthenticatedGoalsIndexRoute
  '/dashboard/checking': typeof AuthenticatedDashboardCheckingIndexRoute
  '/dashboard/external': typeof AuthenticatedDashboardExternalIndexRoute
  '/dashboard/high-yield-savings': typeof AuthenticatedDashboardHighYieldSavingsIndexRoute
  '/dashboard/checking/$accountId/settings': typeof AuthenticatedDashboardCheckingAccountIdSettingsRoute
  '/dashboard/external/$accountId/settings': typeof AuthenticatedDashboardExternalAccountIdSettingsRoute
  '/dashboard/high-yield-savings/$accountId/settings': typeof AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated-chromeless': typeof AuthenticatedChromelessRouteWithChildren
  '/account-under-review': typeof AccountUnderReviewRoute
  '/login': typeof LoginRoute
  '/session-expired': typeof SessionExpiredRoute
  '/_authenticated-chromeless/application-success': typeof AuthenticatedChromelessApplicationSuccessRouteRoute
  '/_authenticated-chromeless/common-application': typeof AuthenticatedChromelessCommonApplicationRouteRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/_authenticated/performance': typeof AuthenticatedPerformanceRouteRoute
  '/_authenticated/transfers': typeof AuthenticatedTransfersRouteRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated-chromeless/common-application/$stepPath': typeof AuthenticatedChromelessCommonApplicationStepPathRoute
  '/_authenticated/dashboard/checking': typeof AuthenticatedDashboardCheckingRouteWithChildren
  '/_authenticated/dashboard/external': typeof AuthenticatedDashboardExternalRouteWithChildren
  '/_authenticated/dashboard/high-yield-savings': typeof AuthenticatedDashboardHighYieldSavingsRouteWithChildren
  '/_authenticated/transfers/accounts-pending': typeof AuthenticatedTransfersAccountsPendingRoute
  '/_authenticated/transfers/add-accounts': typeof AuthenticatedTransfersAddAccountsRoute
  '/_authenticated/transfers/deposit': typeof AuthenticatedTransfersDepositRoute
  '/_authenticated/transfers/high-yield-savings': typeof AuthenticatedTransfersHighYieldSavingsRoute
  '/_authenticated/transfers/in-progress': typeof AuthenticatedTransfersInProgressRoute
  '/_authenticated/transfers/withdraw': typeof AuthenticatedTransfersWithdrawRoute
  '/_authenticated-chromeless/common-application/': typeof AuthenticatedChromelessCommonApplicationIndexRoute
  '/_authenticated/goals/': typeof AuthenticatedGoalsIndexRoute
  '/_authenticated/dashboard/checking/': typeof AuthenticatedDashboardCheckingIndexRoute
  '/_authenticated/dashboard/external/': typeof AuthenticatedDashboardExternalIndexRoute
  '/_authenticated/dashboard/high-yield-savings/': typeof AuthenticatedDashboardHighYieldSavingsIndexRoute
  '/_authenticated/dashboard/checking/$accountId/settings': typeof AuthenticatedDashboardCheckingAccountIdSettingsRoute
  '/_authenticated/dashboard/external/$accountId/settings': typeof AuthenticatedDashboardExternalAccountIdSettingsRoute
  '/_authenticated/dashboard/high-yield-savings/$accountId/settings': typeof AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-under-review'
    | '/login'
    | '/session-expired'
    | '/application-success'
    | '/common-application'
    | '/dashboard'
    | '/performance'
    | '/transfers'
    | '/common-application/$stepPath'
    | '/dashboard/checking'
    | '/dashboard/external'
    | '/dashboard/high-yield-savings'
    | '/transfers/accounts-pending'
    | '/transfers/add-accounts'
    | '/transfers/deposit'
    | '/transfers/high-yield-savings'
    | '/transfers/in-progress'
    | '/transfers/withdraw'
    | '/common-application/'
    | '/goals/'
    | '/dashboard/checking/'
    | '/dashboard/external/'
    | '/dashboard/high-yield-savings/'
    | '/dashboard/checking/$accountId/settings'
    | '/dashboard/external/$accountId/settings'
    | '/dashboard/high-yield-savings/$accountId/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-under-review'
    | '/login'
    | '/session-expired'
    | '/application-success'
    | '/dashboard'
    | '/performance'
    | '/transfers'
    | '/common-application/$stepPath'
    | '/transfers/accounts-pending'
    | '/transfers/add-accounts'
    | '/transfers/deposit'
    | '/transfers/high-yield-savings'
    | '/transfers/in-progress'
    | '/transfers/withdraw'
    | '/common-application'
    | '/goals'
    | '/dashboard/checking'
    | '/dashboard/external'
    | '/dashboard/high-yield-savings'
    | '/dashboard/checking/$accountId/settings'
    | '/dashboard/external/$accountId/settings'
    | '/dashboard/high-yield-savings/$accountId/settings'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated-chromeless'
    | '/account-under-review'
    | '/login'
    | '/session-expired'
    | '/_authenticated-chromeless/application-success'
    | '/_authenticated-chromeless/common-application'
    | '/_authenticated/dashboard'
    | '/_authenticated/performance'
    | '/_authenticated/transfers'
    | '/_authenticated/'
    | '/_authenticated-chromeless/common-application/$stepPath'
    | '/_authenticated/dashboard/checking'
    | '/_authenticated/dashboard/external'
    | '/_authenticated/dashboard/high-yield-savings'
    | '/_authenticated/transfers/accounts-pending'
    | '/_authenticated/transfers/add-accounts'
    | '/_authenticated/transfers/deposit'
    | '/_authenticated/transfers/high-yield-savings'
    | '/_authenticated/transfers/in-progress'
    | '/_authenticated/transfers/withdraw'
    | '/_authenticated-chromeless/common-application/'
    | '/_authenticated/goals/'
    | '/_authenticated/dashboard/checking/'
    | '/_authenticated/dashboard/external/'
    | '/_authenticated/dashboard/high-yield-savings/'
    | '/_authenticated/dashboard/checking/$accountId/settings'
    | '/_authenticated/dashboard/external/$accountId/settings'
    | '/_authenticated/dashboard/high-yield-savings/$accountId/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthenticatedChromelessRoute: typeof AuthenticatedChromelessRouteWithChildren
  AccountUnderReviewRoute: typeof AccountUnderReviewRoute
  LoginRoute: typeof LoginRoute
  SessionExpiredRoute: typeof SessionExpiredRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated-chromeless': {
      id: '/_authenticated-chromeless'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedChromelessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-under-review': {
      id: '/account-under-review'
      path: '/account-under-review'
      fullPath: '/account-under-review'
      preLoaderRoute: typeof AccountUnderReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session-expired': {
      id: '/session-expired'
      path: '/session-expired'
      fullPath: '/session-expired'
      preLoaderRoute: typeof SessionExpiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated-chromeless/application-success': {
      id: '/_authenticated-chromeless/application-success'
      path: '/application-success'
      fullPath: '/application-success'
      preLoaderRoute: typeof AuthenticatedChromelessApplicationSuccessRouteRouteImport
      parentRoute: typeof AuthenticatedChromelessRoute
    }
    '/_authenticated-chromeless/common-application': {
      id: '/_authenticated-chromeless/common-application'
      path: '/common-application'
      fullPath: '/common-application'
      preLoaderRoute: typeof AuthenticatedChromelessCommonApplicationRouteRouteImport
      parentRoute: typeof AuthenticatedChromelessRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/performance': {
      id: '/_authenticated/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AuthenticatedPerformanceRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transfers': {
      id: '/_authenticated/transfers'
      path: '/transfers'
      fullPath: '/transfers'
      preLoaderRoute: typeof AuthenticatedTransfersRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated-chromeless/common-application/': {
      id: '/_authenticated-chromeless/common-application/'
      path: '/'
      fullPath: '/common-application/'
      preLoaderRoute: typeof AuthenticatedChromelessCommonApplicationIndexRouteImport
      parentRoute: typeof AuthenticatedChromelessCommonApplicationRouteRoute
    }
    '/_authenticated-chromeless/common-application/$stepPath': {
      id: '/_authenticated-chromeless/common-application/$stepPath'
      path: '/$stepPath'
      fullPath: '/common-application/$stepPath'
      preLoaderRoute: typeof AuthenticatedChromelessCommonApplicationStepPathRouteImport
      parentRoute: typeof AuthenticatedChromelessCommonApplicationRouteRoute
    }
    '/_authenticated/dashboard/checking': {
      id: '/_authenticated/dashboard/checking'
      path: '/checking'
      fullPath: '/dashboard/checking'
      preLoaderRoute: typeof AuthenticatedDashboardCheckingRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/external': {
      id: '/_authenticated/dashboard/external'
      path: '/external'
      fullPath: '/dashboard/external'
      preLoaderRoute: typeof AuthenticatedDashboardExternalRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/high-yield-savings': {
      id: '/_authenticated/dashboard/high-yield-savings'
      path: '/high-yield-savings'
      fullPath: '/dashboard/high-yield-savings'
      preLoaderRoute: typeof AuthenticatedDashboardHighYieldSavingsRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/goals/': {
      id: '/_authenticated/goals/'
      path: '/goals'
      fullPath: '/goals/'
      preLoaderRoute: typeof AuthenticatedGoalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transfers/accounts-pending': {
      id: '/_authenticated/transfers/accounts-pending'
      path: '/accounts-pending'
      fullPath: '/transfers/accounts-pending'
      preLoaderRoute: typeof AuthenticatedTransfersAccountsPendingRouteImport
      parentRoute: typeof AuthenticatedTransfersRouteRoute
    }
    '/_authenticated/transfers/add-accounts': {
      id: '/_authenticated/transfers/add-accounts'
      path: '/add-accounts'
      fullPath: '/transfers/add-accounts'
      preLoaderRoute: typeof AuthenticatedTransfersAddAccountsRouteImport
      parentRoute: typeof AuthenticatedTransfersRouteRoute
    }
    '/_authenticated/transfers/deposit': {
      id: '/_authenticated/transfers/deposit'
      path: '/deposit'
      fullPath: '/transfers/deposit'
      preLoaderRoute: typeof AuthenticatedTransfersDepositRouteImport
      parentRoute: typeof AuthenticatedTransfersRouteRoute
    }
    '/_authenticated/transfers/high-yield-savings': {
      id: '/_authenticated/transfers/high-yield-savings'
      path: '/high-yield-savings'
      fullPath: '/transfers/high-yield-savings'
      preLoaderRoute: typeof AuthenticatedTransfersHighYieldSavingsRouteImport
      parentRoute: typeof AuthenticatedTransfersRouteRoute
    }
    '/_authenticated/transfers/in-progress': {
      id: '/_authenticated/transfers/in-progress'
      path: '/in-progress'
      fullPath: '/transfers/in-progress'
      preLoaderRoute: typeof AuthenticatedTransfersInProgressRouteImport
      parentRoute: typeof AuthenticatedTransfersRouteRoute
    }
    '/_authenticated/transfers/withdraw': {
      id: '/_authenticated/transfers/withdraw'
      path: '/withdraw'
      fullPath: '/transfers/withdraw'
      preLoaderRoute: typeof AuthenticatedTransfersWithdrawRouteImport
      parentRoute: typeof AuthenticatedTransfersRouteRoute
    }
    '/_authenticated/dashboard/checking/': {
      id: '/_authenticated/dashboard/checking/'
      path: '/'
      fullPath: '/dashboard/checking/'
      preLoaderRoute: typeof AuthenticatedDashboardCheckingIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardCheckingRoute
    }
    '/_authenticated/dashboard/external/': {
      id: '/_authenticated/dashboard/external/'
      path: '/'
      fullPath: '/dashboard/external/'
      preLoaderRoute: typeof AuthenticatedDashboardExternalIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardExternalRoute
    }
    '/_authenticated/dashboard/high-yield-savings/': {
      id: '/_authenticated/dashboard/high-yield-savings/'
      path: '/'
      fullPath: '/dashboard/high-yield-savings/'
      preLoaderRoute: typeof AuthenticatedDashboardHighYieldSavingsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardHighYieldSavingsRoute
    }
    '/_authenticated/dashboard/checking/$accountId/settings': {
      id: '/_authenticated/dashboard/checking/$accountId/settings'
      path: '/$accountId/settings'
      fullPath: '/dashboard/checking/$accountId/settings'
      preLoaderRoute: typeof AuthenticatedDashboardCheckingAccountIdSettingsRouteImport
      parentRoute: typeof AuthenticatedDashboardCheckingRoute
    }
    '/_authenticated/dashboard/external/$accountId/settings': {
      id: '/_authenticated/dashboard/external/$accountId/settings'
      path: '/$accountId/settings'
      fullPath: '/dashboard/external/$accountId/settings'
      preLoaderRoute: typeof AuthenticatedDashboardExternalAccountIdSettingsRouteImport
      parentRoute: typeof AuthenticatedDashboardExternalRoute
    }
    '/_authenticated/dashboard/high-yield-savings/$accountId/settings': {
      id: '/_authenticated/dashboard/high-yield-savings/$accountId/settings'
      path: '/$accountId/settings'
      fullPath: '/dashboard/high-yield-savings/$accountId/settings'
      preLoaderRoute: typeof AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRouteImport
      parentRoute: typeof AuthenticatedDashboardHighYieldSavingsRoute
    }
  }
}

interface AuthenticatedDashboardCheckingRouteChildren {
  AuthenticatedDashboardCheckingIndexRoute: typeof AuthenticatedDashboardCheckingIndexRoute
  AuthenticatedDashboardCheckingAccountIdSettingsRoute: typeof AuthenticatedDashboardCheckingAccountIdSettingsRoute
}

const AuthenticatedDashboardCheckingRouteChildren: AuthenticatedDashboardCheckingRouteChildren =
  {
    AuthenticatedDashboardCheckingIndexRoute:
      AuthenticatedDashboardCheckingIndexRoute,
    AuthenticatedDashboardCheckingAccountIdSettingsRoute:
      AuthenticatedDashboardCheckingAccountIdSettingsRoute,
  }

const AuthenticatedDashboardCheckingRouteWithChildren =
  AuthenticatedDashboardCheckingRoute._addFileChildren(
    AuthenticatedDashboardCheckingRouteChildren,
  )

interface AuthenticatedDashboardExternalRouteChildren {
  AuthenticatedDashboardExternalIndexRoute: typeof AuthenticatedDashboardExternalIndexRoute
  AuthenticatedDashboardExternalAccountIdSettingsRoute: typeof AuthenticatedDashboardExternalAccountIdSettingsRoute
}

const AuthenticatedDashboardExternalRouteChildren: AuthenticatedDashboardExternalRouteChildren =
  {
    AuthenticatedDashboardExternalIndexRoute:
      AuthenticatedDashboardExternalIndexRoute,
    AuthenticatedDashboardExternalAccountIdSettingsRoute:
      AuthenticatedDashboardExternalAccountIdSettingsRoute,
  }

const AuthenticatedDashboardExternalRouteWithChildren =
  AuthenticatedDashboardExternalRoute._addFileChildren(
    AuthenticatedDashboardExternalRouteChildren,
  )

interface AuthenticatedDashboardHighYieldSavingsRouteChildren {
  AuthenticatedDashboardHighYieldSavingsIndexRoute: typeof AuthenticatedDashboardHighYieldSavingsIndexRoute
  AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRoute: typeof AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRoute
}

const AuthenticatedDashboardHighYieldSavingsRouteChildren: AuthenticatedDashboardHighYieldSavingsRouteChildren =
  {
    AuthenticatedDashboardHighYieldSavingsIndexRoute:
      AuthenticatedDashboardHighYieldSavingsIndexRoute,
    AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRoute:
      AuthenticatedDashboardHighYieldSavingsAccountIdSettingsRoute,
  }

const AuthenticatedDashboardHighYieldSavingsRouteWithChildren =
  AuthenticatedDashboardHighYieldSavingsRoute._addFileChildren(
    AuthenticatedDashboardHighYieldSavingsRouteChildren,
  )

interface AuthenticatedDashboardRouteRouteChildren {
  AuthenticatedDashboardCheckingRoute: typeof AuthenticatedDashboardCheckingRouteWithChildren
  AuthenticatedDashboardExternalRoute: typeof AuthenticatedDashboardExternalRouteWithChildren
  AuthenticatedDashboardHighYieldSavingsRoute: typeof AuthenticatedDashboardHighYieldSavingsRouteWithChildren
}

const AuthenticatedDashboardRouteRouteChildren: AuthenticatedDashboardRouteRouteChildren =
  {
    AuthenticatedDashboardCheckingRoute:
      AuthenticatedDashboardCheckingRouteWithChildren,
    AuthenticatedDashboardExternalRoute:
      AuthenticatedDashboardExternalRouteWithChildren,
    AuthenticatedDashboardHighYieldSavingsRoute:
      AuthenticatedDashboardHighYieldSavingsRouteWithChildren,
  }

const AuthenticatedDashboardRouteRouteWithChildren =
  AuthenticatedDashboardRouteRoute._addFileChildren(
    AuthenticatedDashboardRouteRouteChildren,
  )

interface AuthenticatedTransfersRouteRouteChildren {
  AuthenticatedTransfersAccountsPendingRoute: typeof AuthenticatedTransfersAccountsPendingRoute
  AuthenticatedTransfersAddAccountsRoute: typeof AuthenticatedTransfersAddAccountsRoute
  AuthenticatedTransfersDepositRoute: typeof AuthenticatedTransfersDepositRoute
  AuthenticatedTransfersHighYieldSavingsRoute: typeof AuthenticatedTransfersHighYieldSavingsRoute
  AuthenticatedTransfersInProgressRoute: typeof AuthenticatedTransfersInProgressRoute
  AuthenticatedTransfersWithdrawRoute: typeof AuthenticatedTransfersWithdrawRoute
}

const AuthenticatedTransfersRouteRouteChildren: AuthenticatedTransfersRouteRouteChildren =
  {
    AuthenticatedTransfersAccountsPendingRoute:
      AuthenticatedTransfersAccountsPendingRoute,
    AuthenticatedTransfersAddAccountsRoute:
      AuthenticatedTransfersAddAccountsRoute,
    AuthenticatedTransfersDepositRoute: AuthenticatedTransfersDepositRoute,
    AuthenticatedTransfersHighYieldSavingsRoute:
      AuthenticatedTransfersHighYieldSavingsRoute,
    AuthenticatedTransfersInProgressRoute:
      AuthenticatedTransfersInProgressRoute,
    AuthenticatedTransfersWithdrawRoute: AuthenticatedTransfersWithdrawRoute,
  }

const AuthenticatedTransfersRouteRouteWithChildren =
  AuthenticatedTransfersRouteRoute._addFileChildren(
    AuthenticatedTransfersRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRouteRoute: typeof AuthenticatedDashboardRouteRouteWithChildren
  AuthenticatedPerformanceRouteRoute: typeof AuthenticatedPerformanceRouteRoute
  AuthenticatedTransfersRouteRoute: typeof AuthenticatedTransfersRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedGoalsIndexRoute: typeof AuthenticatedGoalsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRouteRoute:
    AuthenticatedDashboardRouteRouteWithChildren,
  AuthenticatedPerformanceRouteRoute: AuthenticatedPerformanceRouteRoute,
  AuthenticatedTransfersRouteRoute:
    AuthenticatedTransfersRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedGoalsIndexRoute: AuthenticatedGoalsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AuthenticatedChromelessCommonApplicationRouteRouteChildren {
  AuthenticatedChromelessCommonApplicationStepPathRoute: typeof AuthenticatedChromelessCommonApplicationStepPathRoute
  AuthenticatedChromelessCommonApplicationIndexRoute: typeof AuthenticatedChromelessCommonApplicationIndexRoute
}

const AuthenticatedChromelessCommonApplicationRouteRouteChildren: AuthenticatedChromelessCommonApplicationRouteRouteChildren =
  {
    AuthenticatedChromelessCommonApplicationStepPathRoute:
      AuthenticatedChromelessCommonApplicationStepPathRoute,
    AuthenticatedChromelessCommonApplicationIndexRoute:
      AuthenticatedChromelessCommonApplicationIndexRoute,
  }

const AuthenticatedChromelessCommonApplicationRouteRouteWithChildren =
  AuthenticatedChromelessCommonApplicationRouteRoute._addFileChildren(
    AuthenticatedChromelessCommonApplicationRouteRouteChildren,
  )

interface AuthenticatedChromelessRouteChildren {
  AuthenticatedChromelessApplicationSuccessRouteRoute: typeof AuthenticatedChromelessApplicationSuccessRouteRoute
  AuthenticatedChromelessCommonApplicationRouteRoute: typeof AuthenticatedChromelessCommonApplicationRouteRouteWithChildren
}

const AuthenticatedChromelessRouteChildren: AuthenticatedChromelessRouteChildren =
  {
    AuthenticatedChromelessApplicationSuccessRouteRoute:
      AuthenticatedChromelessApplicationSuccessRouteRoute,
    AuthenticatedChromelessCommonApplicationRouteRoute:
      AuthenticatedChromelessCommonApplicationRouteRouteWithChildren,
  }

const AuthenticatedChromelessRouteWithChildren =
  AuthenticatedChromelessRoute._addFileChildren(
    AuthenticatedChromelessRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthenticatedChromelessRoute: AuthenticatedChromelessRouteWithChildren,
  AccountUnderReviewRoute: AccountUnderReviewRoute,
  LoginRoute: LoginRoute,
  SessionExpiredRoute: SessionExpiredRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
